import { EntityStatusEnum } from "../enums/entity/entity-status.enum";
import { AbstractDTOBase } from "./abstract.dto.base";

export abstract class AbstractStatusDTOBase extends AbstractDTOBase {
    status?: EntityStatusEnum = EntityStatusEnum.ATIVO;
}